// @flow
import { useQuery, type QueryResult } from 'react-query';

import useClientId from 'common/hooks/useClientId';

/* eslint-disable max-len */
import { WaybillUnusedSummaryResponse } from 'platform/settings/modules/orchestration/models/internal/WaybillUnusedSummaryResponse';
import { pregenWaybillUnusedSummary as pregenWaybillUnusedSummaryApi } from 'platform/settings/modules/orchestration/api';
/* eslint-enable max-len */

const useGetWaybillUnusedSummary = (
    searchKey?: string
): QueryResult<WaybillUnusedSummaryResponse> => {
    const clientId = useClientId();

    return useQuery({
        queryKey: ['client', clientId, 'waybill-unused-summary', { searchKey }],
        queryFn: async () => {
            const params: {
                clientId: string,
                searchKey?: string
            } = { clientId };

            if (searchKey) {
                params.searchKey = searchKey;
            }

            const data = await pregenWaybillUnusedSummaryApi.fetch(params);

            return WaybillUnusedSummaryResponse.fromJS(data);
        },
        refetchOnWindowFocus: false
    });
};

export default useGetWaybillUnusedSummary;
